import React, { FC, useEffect, useState } from 'react';

import { Menu, Dropdown } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import CustomIcon from '@components/utils/CustomIcon';
import { ClockIcon, DownArrowIcon } from '@assets/icons';

import {
  Wrapper,
  MenuWrapper,
  DropdownButonStyled,
  Container,
  MainLabel,
  Styledlabel,
  LabelContainer,
  IconWrapper,
} from './styled';

const getTimes = () => {
  const times: string[] = [];

  for (let i = 0; i < 24; i++) {
    const time = i < 10 ? `0${i}:00` : `${i}:00`;

    times.push(time);
  }

  return times;
};

export interface ITimePicker {
  title: string;
  onChange: (value: string) => void;
  defaultValue: string;
  time: string;
  containerClassName?: string;
  alignItems?: 'center' | 'flex-start' | 'flex-end';
}

const TimePickerComp: FC<ITimePicker> = ({
  onChange,
  title,
  defaultValue,
  time,
  containerClassName,
  alignItems = 'center',
}) => {
  const { md } = useBreakpoint();
  const times = getTimes();

  const [localTime, setLocalTime] = useState(defaultValue || times[0]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    setLocalTime(time);
  }, [time]);

  const handleTimeSelected = (timeIndex: number) => {
    setLocalTime(times[timeIndex]);
    onChange(times[timeIndex]);
    setDropdownVisible(false);
  };

  const menu = (
    <MenuWrapper>
      <Menu selectedKeys={[times.indexOf(localTime).toString()]}>
        {times.map((item, i) => (
          <Menu.Item key={i} onClick={() => handleTimeSelected(i)}>
            {item}
          </Menu.Item>
        ))}
      </Menu>
    </MenuWrapper>
  );

  return (
    <Container className={containerClassName}>
      <Wrapper>
        <Dropdown
          overlay={menu}
          placement='bottomCenter'
          trigger={['click']}
          open={dropdownVisible}
          onOpenChange={(visible) => setDropdownVisible(visible)}
        >
          <DropdownButonStyled>
            {!(md === undefined || md) ? (
              <CustomIcon
                icon={ClockIcon}
                fontSize={28}
                paletteColor='primaryBrand'
              />
            ) : null}
            <LabelContainer alignItems={alignItems}>
              <MainLabel>{title}</MainLabel>
              <Styledlabel>{localTime}</Styledlabel>
            </LabelContainer>

            <IconWrapper>
              {!(md === undefined || md) ? (
                <CustomIcon
                  fontSize={16}
                  icon={DownArrowIcon}
                  paletteColor='blackAlpha'
                />
              ) : null}
            </IconWrapper>
          </DropdownButonStyled>
        </Dropdown>
      </Wrapper>
    </Container>
  );
};

export default TimePickerComp;
